var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.22035 18.2369C7.33996 29.3858 16.4368 38.2221 27.7297 43.0156L29.543 43.8236C31.5511 44.7178 33.8103 44.8745 35.9226 44.2662C38.035 43.6579 39.8648 42.3235 41.0897 40.4983L43.4604 36.9676C43.8313 36.4139 43.9815 35.7413 43.8813 35.0824C43.7811 34.4235 43.4378 33.826 42.919 33.4076L34.887 26.9276C34.6073 26.7021 34.2849 26.5354 33.9391 26.4376C33.5934 26.3398 33.2314 26.3129 32.875 26.3585C32.5186 26.4041 32.1751 26.5212 31.8651 26.7029C31.5551 26.8845 31.285 27.1269 31.071 27.4156L28.5857 30.7676C22.206 27.6168 17.042 22.4519 13.8924 16.0716L17.2417 13.5863C17.5303 13.3723 17.7728 13.1022 17.9544 12.7922C18.1361 12.4822 18.2532 12.1387 18.2988 11.7823C18.3444 11.4258 18.3175 11.0639 18.2197 10.7182C18.1219 10.3724 17.9552 10.05 17.7297 9.77027L11.2497 1.73827C10.8313 1.21948 10.2338 0.876174 9.57485 0.77598C8.91594 0.675785 8.24339 0.825966 7.68969 1.19694L4.13502 3.58094C2.29875 4.81235 0.95926 6.65564 0.355159 8.78245C-0.248942 10.9093 -0.078418 13.1815 0.836353 15.1943L2.22035 18.2369Z",
    fill: "#1A73E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.97f20fb2ff90c61b09145b659b8389aa.svg";
export { ForwardRef as ReactComponent };